import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, ModalController } from '@ionic/angular';
import { BasePage } from 'src/app/pages/base.page';
import { AccountService } from 'src/app/shared/services/account.service';
import { ChatService } from 'src/app/shared/services/chat.service';

@Component({
  selector: 'app-message-button',
  templateUrl: './message-button.component.html',
  styleUrls: ['./message-button.component.scss'],
})
export class MessageButtonComponent extends BasePage {
  @Input() buttonText = 'Message';

  @Input() buttonColor = 'primary';

  @Input() buttonFill = 'solid';

  @Input() userId;

  @Input() channelUrl;

  constructor(
    public loadingCtrl: LoadingController,
    public router: Router,
    public modalCtrl: ModalController,
    private chatService: ChatService,
    private accountService: AccountService,
  ) {
    super('MessageButtonComponent');
  }

  async contact() {
    this.modalCtrl.dismiss();
    if (this.accountService.userIs('consumer')) {
      try {
        this.showLoading();
        const res = await this.chatService.createOneToOneChannel(this.userId);
        if (res?.sendbirdChannelDetail?.channelUrl) {
          this.showConversation(res?.sendbirdChannelDetail?.channelUrl);
        }
        this.hideLoading();
      } catch (e) {
        this.hideLoading();
        const smsVerified = await this.checkAccountVerification();
        // Display generic error if request failed due to some other reason in sms verified client
        if (smsVerified) {
          this.showErrorAlert('Unable to create conversation, please try again');
        }
      }
    }
    if (this.accountService.userIs('carer')) {
      this.showConversation(this.channelUrl);
    }
  }

  /**
   * Check acoount verification if channel create api fails
   */
  async checkAccountVerification(): Promise<boolean> {
    try {
      this.showLoading();
      const resAccount = await this.accountService.getPhoneVerificationStatus();
      return resAccount.contactPhoneVerified;
    } catch {
      this.showErrorAlert('Unable to fetch account details');
    } finally {
      this.hideLoading();
    }
  }

  private showConversation(channelUrl): void {
    this.router.navigate(['/conversation', channelUrl]);
  }
}
